var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 12.0001L10.79 14.4201L15.62 9.58008",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.45007C11.44 1.86007 12.57 1.86007 13.27 2.45007L14.85 3.81007C15.15 4.07007 15.71 4.28007 16.11 4.28007H17.81C18.87 4.28007 19.74 5.15007 19.74 6.21007V7.91007C19.74 8.30007 19.95 8.87007 20.21 9.17007L21.57 10.7501C22.16 11.4401 22.16 12.5701 21.57 13.2701L20.21 14.8501C19.95 15.1501 19.74 15.7101 19.74 16.1101V17.8101C19.74 18.8701 18.87 19.7401 17.81 19.7401H16.11C15.72 19.7401 15.15 19.9501 14.85 20.2101L13.27 21.5701C12.58 22.1601 11.45 22.1601 10.75 21.5701L9.17 20.2101C8.87 19.9501 8.31 19.7401 7.91 19.7401H6.18C5.12 19.7401 4.25 18.8701 4.25 17.8101V16.1001C4.25 15.7101 4.04 15.1501 3.79 14.8501L2.44 13.2601C1.86 12.5701 1.86 11.4501 2.44 10.7601L3.79 9.17007C4.04 8.87007 4.25 8.31007 4.25 7.92007V6.20007C4.25 5.14007 5.12 4.27007 6.18 4.27007H7.91C8.3 4.27007 8.87 4.06007 9.17 3.80007L10.75 2.45007Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default ForwardRef;